import { render, staticRenderFns } from "./diffCheckHole.vue?vue&type=template&id=db70d772&scoped=true&"
import script from "./diffCheckHole.vue?vue&type=script&lang=js&"
export * from "./diffCheckHole.vue?vue&type=script&lang=js&"
import style0 from "./diffCheckHole.vue?vue&type=style&index=0&id=db70d772&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db70d772",
  null
  
)

export default component.exports